import React from 'react';
import moment from 'moment';

const SectionDate = ({
  event,
  setEvent,
  dateAlert,
  eventDateError,
  isDateChangeProhibitionDisplay,
  isEventEndDatetimeTouched,
  handleEventDateInput,
}) => {
  const maxMoment = moment().add(6, 'months');

  const maxDatePicker = maxMoment.format('YYYY/MM/DD');
  const maxDateTimeLocal = maxMoment.format('YYYY-MM-DDTHH:mm');

  React.useEffect(() => {
    if (window.innerWidth >= 768) {
      $('.datetimepicker').each(function () {
        $(this).datetimepicker({
          format: 'Y/m/d H:i',
          lang: 'ja',
          scrollInput: true,
          timepicker: true,
          step: 5,
          maxDate: maxDatePicker,
        });
      });
    }
  }, [maxDatePicker]);

  const isDesktop = window.innerWidth >= 768;
  const datetimeFormType = isDesktop ? 'text' : 'datetime-local';
  const datetimeFormat = isDesktop ? 'YYYY/MM/DD HH:mm' : 'YYYY-MM-DDTHH:mm';

  return (
    <section id="event_date">
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          イベント日時
          <span className="text-fz-14px text-fw-bold text-orange mb-2 mt-1 ml-2 d-inline-block">
            必須
          </span>
        </p>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div
          className={`container col-md-8 col-lg-6 ${
            !!eventDateError ? 'bg-light-pink' : ''
          }`}
        >
          {dateAlert && (
            <p className="text-danger text-fz-small mb-0">{dateAlert}</p>
          )}
          {isDateChangeProhibitionDisplay && (
            <p className="text-danger text-fz-small mb-0">
              日付を変更することはできません。
            </p>
          )}
          {eventDateError && (
            <p className="text-danger text-fz-small mb-0">{eventDateError}</p>
          )}
          <label
            htmlFor="event-start-datetime-input-form"
            className="row justify-content-between p-3_5 border-bottom"
          >
            <p className="p-0 mb-0">開始時刻</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
              id="event-start-datetime-input-form"
              value={
                event.event_date
                  ? moment(event.event_date).format(datetimeFormat)
                  : ''
              }
              onChange={(e) => {
                handleEventDateInput(e);
              }}
              onBlur={(e) => {
                handleEventDateInput(e);
              }}
              placeholder="必須"
              autoComplete="off"
              {...(!isDesktop && {
                max: maxDateTimeLocal,
              })}
            />
          </label>
          <label
            htmlFor="event-end-datetime-input-form"
            className="row justify-content-between p-3_5"
          >
            <p className="pr-2 mb-0">終了時刻</p>
            <input
              type={datetimeFormType}
              className="datetimepicker form-style-reset p-0 textarea--eventreport text-right bg-gray"
              id="event-end-datetime-input-form"
              value={
                event.event_end_datetime
                  ? moment(event.event_end_datetime).format(datetimeFormat)
                  : ''
              }
              onChange={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  event_end_datetime: e.target.value,
                }));
              }}
              onBlur={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({
                  ...prev,
                  event_end_datetime: e.target.value,
                }));
              }}
              placeholder="必須"
              autoComplete="off"
              {...(!isDesktop && {
                max: maxDateTimeLocal,
              })}
            />
          </label>
        </div>
      </div>
    </section>
  );
};

export default SectionDate;
